import type { CityConfig } from "@/pages/city-template/types";

export const newPaltzConfig: CityConfig = {
  city: "New Paltz",
  state: "New York",
  stateAbbr: "NY",
  slug: "new-paltz",
  route: "/cities/new-paltz",
  title: "Emergency & Expedited Passport New Paltz NY | Same Day Passport Ulster County",
  metaDescription:
    "Emergency passport New Paltz NY — same day, 24-hour, and 3-5 day expedited passport processing for SUNY New Paltz students and Ulster County residents. Fast Passport Center serves New Paltz, Kingston, Highland, and all Hudson Valley communities.",
  h1: "Emergency & Expedited Passport Services in New Paltz, NY",
  heroSubtitle:
    "New Paltz's fast passport solution — from the Shawangunk Ridge to the Wallkill Valley. Whether you're flying out of Stewart International or Albany, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20New%20Paltz%20New%20York%20with%20SUNY%20New%20Paltz%20campus%2C%20Shawangunk%20Ridge%20mountain%20backdrop%2C%20Wallkill%20Valley%20farmland%2C%20historic%20town%20center%2C%20charming%20Hudson%20Valley%20college%20town%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20Hudson%20Valley%20landscape%20with%20mountain%20vista&width=1600&height=700&seq=ny-new-paltz-hero-001&orientation=landscape",
  heroImageAlt: "New Paltz New York with Shawangunk Ridge mountain backdrop and SUNY New Paltz campus",
  geoPosition: "41.7476; -74.0865",
  geoPlacename: "New Paltz, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~85 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "New Paltz", zips: "12561" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "Highland", zips: "12528" },
    { name: "Rosendale", zips: "12472" },
    { name: "Gardiner", zips: "12525" },
    { name: "Marlboro", zips: "12542" },
    { name: "Milton", zips: "12547" },
    { name: "Lloyd", zips: "12401" },
    { name: "Esopus", zips: "12429" },
    { name: "Woodstock", zips: "12498" },
    { name: "Saugerties", zips: "12477" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Red Hook", zips: "12571" },
    { name: "Poughkeepsie", zips: "12601-12604" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Newburgh", zips: "12550, 12551, 12552, 12555" },
    { name: "Middletown", zips: "10940, 10941" },
    { name: "Port Ewen", zips: "12466" },
    { name: "Hurley", zips: "12443" },
    { name: "Ulster", zips: "12480" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230, 12231, 12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for New Paltz travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for New Paltz residents and SUNY students 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Ulster & Shawangunk Region",
      desc: "New Paltz, Kingston, Highland, Gardiner, and the entire Wallkill Valley — we serve SUNY New Paltz students and all Hudson Valley communities.",
    },
  ],
  testimonials: [
    {
      name: "Amanda S.",
      location: "SUNY New Paltz Student",
      rating: 5,
      text: "Studying abroad in Barcelona next semester. Fast Passport Center got my new passport processed in 5 days. They were incredibly helpful with all the student documentation.",
      service: "New Passport",
    },
    {
      name: "Robert T.",
      location: "Highland, NY",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center. Chose the 5-day option and had it back in 4. The agent reviewed everything before submission.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa M.",
      location: "Rosendale, NY",
      rating: 5,
      text: "Had a family emergency in Ireland. Fast Passport Center got my emergency passport processed in 2 days. They went above and beyond during a stressful time.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "newpaltz-1",
      name: "New Paltz Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "2 North Chestnut Street",
      city: "New Paltz",
      state: "NY",
      zip: "12561",
      phone: "845-255-1100",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Downtown New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major New Paltz passport acceptance facility. Convenient for SUNY New Paltz students and residents. First-time applicants must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "newpaltz-2",
      name: "Kingston Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "Clarence Avenue",
      city: "Kingston",
      state: "NY",
      zip: "12401",
      phone: "845-331-5100",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Kingston (north of New Paltz)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Kingston, Esopus, and Port Ewen residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "newpaltz-3",
      name: "Highland Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "2 Library Lane",
      city: "Highland",
      state: "NY",
      zip: "12528",
      phone: "845-691-2316",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Highland (east of New Paltz)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Highland, Lloyd, and east Ulster County residents.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in New Paltz?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for New Paltz residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in New Paltz?",
      a: "The New Paltz Post Office at 2 North Chestnut Street is the major New Paltz passport acceptance facility. The Kingston Main Post Office on Clarence Avenue and Highland Post Office at 2 Library Lane are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in New Paltz?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, and UPS Store locations throughout New Paltz, Kingston, and Highland. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in New Paltz?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your New Paltz passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in New Paltz?",
      a: "The fastest way to renew a passport in New Paltz is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in New Paltz?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in New Paltz and all Ulster County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in New Paltz?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in New Paltz. We serve the Hudson Valley and all of Ulster County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — New Paltz", address: "various CVS locations across New Paltz, Kingston, and Highland", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — New Paltz", address: "various Walgreens locations throughout New Paltz and Ulster County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — New Paltz", address: "various UPS Store locations in New Paltz and Kingston", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — New Paltz", address: "various FedEx Office locations across New Paltz and the Hudson Valley", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — New Paltz",
      address: "1 South Chestnut Street, New Paltz, NY 12561",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "New Paltz DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Kingston",
      address: "350 Washington Avenue, Kingston, NY 12401",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Kingston DMV office serving north New Paltz, Kingston, and Woodstock residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Poughkeepsie",
      address: "2527 South Road, Poughkeepsie, NY 12601",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Poughkeepsie DMV office serving east New Paltz, Highland, and Dutchess County communities.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "~25 miles from New Paltz",
      address: "1st Street, New Windsor, NY 12553",
      note: "The closest airport to New Paltz with flights to major U.S. hubs including Florida. Perfect for SUNY New Paltz students and Hudson Valley travelers.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "~75 miles from New Paltz",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Major international airport in Albany with flights to Europe and worldwide destinations. Alternative for New Paltz area travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~90 miles from New Paltz",
      address: "JFK Expy & S Cargo Rd, Jamaica, NY 11430",
      note: "NYC's major international airport with direct flights to every continent. Alternative for New Paltz area travelers heading abroad.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For New Paltz travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for New Paltz residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for New Paltz residents and SUNY students with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for New Paltz residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in New Paltz, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for New Paltz residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for New Paltz travelers with immediate departure needs from Stewart International or Albany." },
    { name: "Passport Renewal", description: "Fast passport renewal for New Paltz residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for New Paltz residents and SUNY students." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for New Paltz residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in New Paltz and Ulster County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in New Paltz." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many New Paltz travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many New Paltz travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our New Paltz team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your New Paltz address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Utica", route: "/cities/utica" },
    { name: "Schenectady", route: "/cities/schenectady" },
    { name: "Troy", route: "/cities/troy" },
    { name: "Saratoga Springs", route: "/cities/saratoga-springs" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "Plattsburgh", route: "/cities/plattsburgh" },
    { name: "Watertown", route: "/cities/watertown" },
    { name: "Ogdensburg", route: "/cities/ogdensburg" },
    { name: "Glens Falls", route: "/cities/glens-falls" },
    { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    { name: "Newburgh", route: "/cities/newburgh" },
    { name: "New Rochelle", route: "/cities/new-rochelle" },
    { name: "White Plains", route: "/cities/white-plains" },
    { name: "Kingston", route: "/cities/kingston" },
    { name: "Middletown", route: "/cities/middletown-ny" },
    { name: "Rhinebeck", route: "/cities/rhinebeck" },
    { name: "Hyde Park", route: "/cities/hyde-park" },
    { name: "Red Hook", route: "/cities/red-hook" },
    { name: "Hudson", route: "/cities/hudson-ny" },
    { name: "Catskill", route: "/cities/catskill" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves New Paltz and all of Ulster County as a remote courier service. We do not have a physical office in New Paltz, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Ulster County area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to New Paltz and all of Ulster County. From the Shawangunk Ridge to the Wallkill Valley, from SUNY New Paltz to Gardiner — we serve the Hudson Valley with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve New Paltz and all surrounding communities across Ulster County and the Wallkill Valley. Whether you're in Kingston, Highland, Rosendale, or Gardiner, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our New Paltz customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes New Paltz travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Hudson Valley and SUNY New Paltz travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in New Paltz. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default newPaltzConfig;